import styled from 'styled-components'

export const FeaturePointsStyled = styled.div`
  grid-column: span 2 / span 2;

  display: grid;
  gap: ${(props) => props.theme.space.large};
  grid-template-columns: repeat(
    auto-fit,
    minmax(${(props) => props.theme.typography.pxToRem(185)}, 1fr)
  );

  @media (max-width: ${(props) => props.theme.typography.pxToRem(1550)}) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: ${(props) => props.theme.typography.pxToRem(1160)}) {
    grid-column: unset;
  }
`
